module.exports = __webpack_public_path__ + "img/蛤蚧.fc55eb29.jpg";